// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_vr-0";
export var checkoutRateBadgeLink = "_vr-1";